// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__3i9oj","assignButton":"CreateEditEquipmentSchedule_assignButton__2idNF"};